<div class="container-fluid" #header>
  <div class="row col">
    <select class="q-main-select" [(ngModel)]="idBo" [disabled]="!multiBo">
      <option value="" title="aucun">-----</option>
      <option value="ALL" title="Tous">Tous</option>
      <option *ngFor="let option of BOs" [value]="option.Value" [title]="option.Tooltip">{{option.Text}}</option>
    </select>

    <div class="q-check mx-1 align-items-center d-flex">
      <input type="checkbox" id="check" [(ngModel)]="onlyReattached" />
      <label for="check" class="m-0">
        <span></span>uniquement rattaché(es) à l'objet {{reattachedName}}
      </label>
    </div>

    <div class="ml-2">
      <button *ngIf="!displayGrid" class="q-btn q-white" (click)="Search();">Lancer la recherche</button>
      <button *ngIf="displayGrid" class="q-btn q-white" (click)="displayGrid = false">Nouvelle recherche</button>
    </div>
  </div>
</div>
<div *ngIf="displayGrid" class="row col m-2">
  <button class="q-btn q-main" (click)="OnSave();" [disabled]="!Idents || Idents.length == 0">Ajouter</button>
</div>
<q-bodisplay *ngIf="initBo && !displayGrid" [ngClass]="{'d-none': loadDataGrid}" [(save)]="saveBo" [modeBo]="modeBo.Find" [item]="model" [filter]="filtre" (sendWhere)="GetWhere($event)"></q-bodisplay>
<div class="w-100 d-flex justify-content-center"><i class="fas fa-spin fa-spinner fa-pulse q-c-main fa-3x" *ngIf="loadDataGrid"></i></div>
<q-customgrid *ngIf="displayGrid" class='h-100 w-100'
              [ngClass]="{'invisible': loadDataGrid}"
              [autoSizeColumnsOnInit]="true"
              [customgridParam]="customgridParam"
              (selectChanged)="OnSelectionChanged($event)"
              [customgridHeight]="'calc(80vh - ' + header.offsetHeight + 'px)'"
              #agGrid>
</q-customgrid>
